import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["checkbox", "submit", "label"];

  declare checkboxTarget: HTMLInputElement;
  declare submitTarget: HTMLButtonElement;
  declare labelTarget: HTMLLabelElement;

  modal: Modal;

  connect() {
    this.modal = new Modal(this.element);
    this.modal.show();
  }

  closeModal() {
    this.modal.hide();
  }

  checkboxChanged() {
    const isChecked = this.checkboxTarget.checked;
    this.submitTarget.disabled = !isChecked;

    if (isChecked) {
      this.labelTarget.classList.add("is_checked");
    } else {
      this.labelTarget.classList.remove("is_checked");
    }
  }
}
